import SolrService from '../../common/solr.service';

export default {
  name: 'NewsModalContent',
  data() {
    return {
      exhibitor: null,
    };
  },
  props: {
    entry: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
    existingEntries: {
      type: Array,
      default: [],
    },
  },
  methods: {
    setFavourite(entryId) {
      this.$emit('set-favourite', entryId);
    },
    isFavourite(id) {
      if (this.existingEntries.includes(id)) {
        const index = this.existingEntries.indexOf(id);
        return index > -1;
      }
      return false;
    },
  },
  mounted() {
    if (this.entry.exhibitor_id) {
      this.exhibitor = SolrService.getExhibitorForNews(`MkdbExhibitorIndexBundle|||Documents|||Exhibitor|||${this.entry.exhibitor_id}`)
        .then((response) => {
          this.exhibitor = response.data.response.docs[0]; // eslint-disable-line
          this.$forceUpdate();
        });
    }
  },
};
